enum SigninConfirmatinMode {
    PIN_OR_EMAIL = "pin_or_email"
}

export default SigninConfirmatinMode;